import { getField } from 'vuex-map-fields';

export default {
  activeInbox: state => state.activeInbox,
  currentAssignment: state => state.currentAssignment,
  currentFolder: state => state.currentFolder,
  stats: state => state.stats,

  apiError: state => state.apiError,
  getField,
};
